import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { Navbar } from '../../shared/components/navbar/navbar';
import { EmptyState } from '../../shared/components/empty-state/empty-state';

@Component({
  selector: 'app-brain-activity-detail',
  standalone: true,
  imports: [CommonModule, Sidebar, Navbar, EmptyState],
  templateUrl: './brain-activity-detail.html',
  styleUrl: './brain-activity-detail.css'
})
export class BrainActivityDetail {}
